import { styled } from "styled-components";
import { Card, Centering } from "styles/mixinStyles";

const CardContainer = styled(Card)`
  width: 90vw;
  position: relative;
  border: 1px solid black;
  margin-bottom: 2vw;
`;

const CardInfo = styled(Centering)`
  width: 70vw;
  cursor: pointer;
  h2 {
    font-weight: 800;
    font-size: 1.4rem;
  }
`;

export { CardContainer, CardInfo };

